// El duelo de clase (G20): el alumno con su token de aula, el profesor con su sesión.
//
// LA LLAVE DEL ALUMNO ES LA DEL AULA y viaja como viaja la lección: en `X-Aula`, en esta
// petición y en ninguna más (`lib/api/aula.js`). El `jugador` es una cadena al azar que da el
// servidor al entrar y vive en la memoria de la pestaña: ni se guarda en el navegador ni dice
// quién es nadie. Recargar la página te saca del duelo, y es a propósito: el modo aula no deja
// nada guardado, ni un mote.
import { api } from "./client";
import { CABECERA_AULA } from "./aula";

const conAula = (token) => ({ headers: { [CABECERA_AULA]: token } });

// ---- el alumno ----
export const verDueloDeAula = async (token, jugador = "") =>
  (await api.get("/aula/duelo", { params: { jugador }, ...conAula(token) })).data;

export const entraEnElDuelo = async (token, apodo, rasgos) =>
  (await api.post("/aula/duelo/entrar", { apodo, rasgos }, conAula(token))).data;

export const respondeEnElDuelo = async (token, jugador, n, opcion) =>
  (await api.post("/aula/duelo/respuesta", { jugador, n, opcion }, conAula(token))).data;

// ---- el profesor ----
const delDuelo = (communityId) => `/admin/communities/${communityId}/duelo`;

export const creaDuelo = async (communityId, lessonId, modo) =>
  (await api.post(delDuelo(communityId), { lesson_id: lessonId, modo })).data;
export const verDueloDeClase = async (communityId) => (await api.get(delDuelo(communityId))).data;
export const empiezaDuelo = async (communityId) => (await api.post(`${delDuelo(communityId)}/empieza`)).data;
export const avanzaDuelo = async (communityId) => (await api.post(`${delDuelo(communityId)}/avanza`)).data;
export const terminaDuelo = async (communityId) => (await api.delete(delDuelo(communityId))).data;
